import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function cadastrodvec(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@cadastrodvec/FIND_CADASTRODVEC':
      case '@cadastrodvec/UPDATE_CADASTRODVEC':
      case '@cadastrodvec/DELETE_CADASTRODVEC':
      case '@cadastrodvec/STORE_CADASTRODVEC':
      case '@cadastrodvec/CADASTRODVEC_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@cadastrodvec/SUCCESS_REMOVE':
      case '@cadastrodvec/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@cadastrodvec/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.cadastrodvec;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@cadastrodvec/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.cadastrodvec;
        break;
      }

      case '@cadastrodvec/RECORD_FILTERING': {
        draft.loading = true;
        draft.params = { ...draft.params, ...action.payload.params };
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
